/** @file tileStartImage: the pixels a Tile tab starts from: the slot's tile in the preview, or transparent. */
import type { ImageSlot } from '@zilo/pose3d-format/types/facet';
import { createImage } from '@zilo/pose3d-image-io/image/createImage';
import type { Image } from '@zilo/pose3d-image-io/types/image';
import type { LoadedBundle } from '@zilo/pose3d-runtime-babylon/bundle/loadedBundle';
import { thumbnailOf } from '../../panels/art/thumbnailOf';
import { tileFitImage } from './tileFitImage';

/**
 * An empty slot starts fully transparent; a filled one starts as `thumbnailOf(bundle, slot)` (padded to the tile size
 * should the sheet rect differ). Null while a filled slot's preview is not built yet (the tab waits for it).
 */
export function tileStartImage(slot: ImageSlot, bundle: LoadedBundle | null): Image | null {
  if (slot.status === 'empty') return createImage(slot.size[0], slot.size[1]);
  const tile = thumbnailOf(bundle, slot);
  return tile === null ? null : tileFitImage(tile, slot.size, 'pad');
}
